<template>
  <div
    ref="modal"
    class="modal fade"
    :id="id"
    tabindex="-1"
    role="dialog"
    aria-labelledby="status-error"
    aria-hidden="true"
    @click="hide()"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" @click.stop="function () {}">
        <YouTube
          v-if="initYT"
          :src="youtubeUrl"
          @ready="onReady"
          ref="youtube"
        />
      </div>
    </div>
  </div>
</template>
<script>
import YouTube from "vue3-youtube";
import { genNonDuplicateID } from "@/utils/util";
import { loadYouTubeIframeApi } from "@/utils/YouTubeApiUtil";

export default {
  data() {
    return {
      id: genNonDuplicateID(),
      modal: null,
      youtubeUrl: "",
      initYT: false,
    };
  },

  mounted() {
    this.modal = $(this.$refs.modal);
  },
  props: {},
  components: {
    YouTube,
  },
  methods: {
    init() {},
    async show(youtubeUrl) {
      this.youtubeUrl = youtubeUrl;
      await loadYouTubeIframeApi();
      this.initYT = true;
      this.modal.modal("show");
    },
    hide() {
      const active = document.activeElement;

      if (active) {
        active.blur();
      }
      this.modal.modal("hide");
      if (this.$refs.youtube && this.$refs.youtube.stopVideo) {
        this.$refs.youtube.stopVideo();
      }
      this.youtubeUrl = "";
    },
    onReady() {
      if (this.$refs.youtube && this.$refs.youtube.playVideo) {
        this.$refs.youtube.playVideo();
      }
    },
  },
  watch: {},
};
</script>

